import {
  HIDE_MODAL,
  SHOW_REGISTER,
  SHOW_LOGIN,
  SHOW_MODAL,
  SHOW_RESET_PASSWORD,
  SHOW_VERIFY_EMAIL,
  SHOW_STEPS,
  HIDE_STEPS,
} from "./types";

// By default we show register
export const showRegister = () => dispatch => {
  dispatch({
    type: SHOW_REGISTER,
  });
};
export const showLogin = () => dispatch => {
  dispatch({
    type: SHOW_LOGIN,
  });
};
export const hideModal = () => dispatch => {
  dispatch({
    type: HIDE_MODAL,
  });
};
export const showSteps = () => dispatch => {
  dispatch({
    type: SHOW_STEPS,
  });
};
export const hideSteps = () => dispatch => {
  dispatch({
    type: HIDE_STEPS,
  });
};
export const setShowModal = () => dispatch => {
  dispatch({
    type: SHOW_MODAL,
  });
};
export const setShowResetPassword = () => dispatch => {
  dispatch({
    type: SHOW_RESET_PASSWORD,
  });
};
export const setShowVerifyEmail = () => dispatch => {
  dispatch({
    type: SHOW_VERIFY_EMAIL,
  });
};
